const $ = jQuery.noConflict();

'use strict';
const ScrollToSection = {
	$domButton: $('.js-hero-scroll-btn'),

	init: function() {
		this.scroll();
	},
	scroll: function() {
		this.$domButton.on('click', function() {
			$('html, body').animate({
				scrollTop: $(this).closest('.hero-scroll-section').next().offset().top
			}, 'slow');
		});
	}
};
export default ScrollToSection;



